



































































































































































import Vue from 'vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import XForm from '@/components/atoms/Form/XForm.vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XDropdown, {
  OptionEntry,
} from '@/components/atoms/Dropdown/XDropdown.vue'
import prefectures from '@/packages/Prefectures'
import XButton from '@/components/atoms/Button/XButton.vue'
import XZipInput from '@/components/atoms/Input/XZipInput.vue'
import { AddressResponse } from '@/mixin/zipcodeMixin'

import XTel from '@/components/atoms/Input/XTel.vue'
import { Mutation } from '@/types/generated/graphql'
import MUTATION_CREATE from '@/graphql/partner/createAgentSalesDestination.gql'

export type Input = {
  partnerId: string
  storeId: string
  firstName?: string
  lastName?: string
  firstNameKana?: string
  lastNameKana?: string
  zipCode?: string
  prefId?: number
  address1?: string
  address2?: string
  phone?: string
  email?: string
}

type Data = {
  input: Input
}

type Methods = {
  setAddress: (address: AddressResponse) => void
  onClickSave: () => void
}
type Computed = {
  prefOptions: OptionEntry<number | undefined>[]
}

type Props = {
  partnerId: string
  storeId: string
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'AgentDestinationForm',
  components: {
    XButton,
    XForm,
    XFormLabel,
    XInput,
    XDropdown,
    XTel,
    XZipInput,
  },
  data() {
    return {
      input: {
        partnerId: this.partnerId,
        storeId: this.storeId,
        firstName: undefined,
        lastName: undefined,
        firstNameKana: undefined,
        lastNameKana: undefined,
        zipCode: undefined,
        prefId: undefined,
        address1: undefined,
        address2: undefined,
        phone: undefined,
        email: undefined,
      },
    }
  },
  methods: {
    setAddress(address: AddressResponse) {
      this.input.prefId = address.prefId
      this.input.address1 = address.locality + address.street
    },
    async onClickSave() {
      await this.$apollo.mutate<Mutation>({
        mutation: MUTATION_CREATE,
        variables: {
          input: this.input,
        },
      })
      await this.$emit('click:cancel')
    },
  },
  computed: {
    prefOptions() {
      const options = prefectures().map((e) => {
        return { value: e.id, label: e.name }
      })

      const emptyOpt = { value: undefined, label: '' }
      return [emptyOpt, ...options]
    },
  },
  props: {
    partnerId: {
      type: String,
      required: true,
    },
    storeId: {
      type: String,
      required: true,
    },
  },
})
